import React from 'react';
import { CtaButton } from './CtaButton';
import { LadderLegend } from './LadderLegend';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/q4aLzDG1Zn4CmLKZvzdk4M/Prod_Principal_mockup-memory-care-activity-ready.png';
const chips = ['6 Volumes', '90 Activities', '270 Ready-to-run versions', '15 · 30 · 45-min sessions', '5 Bonuses'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Print in black and white or lead from your phone'];
export function Hero() {
  return <section className="w-full bg-cream text-ink" data-id="element-111" data-mp="xbpaiy7sbmbc">
      <div className="mx-auto max-w-6xl px-5 pb-14 pt-8 sm:pb-20 sm:pt-12 lg:pt-16" data-id="element-112" data-mp="sbb5lp1hcshj">
        {/* Mobile order: headline → product photo → details. Desktop: text left, photo right. */}
        <div className="grid gap-7 lg:grid-cols-[1.05fr_.95fr] lg:gap-x-14 lg:gap-y-6" data-id="element-113" data-mp="nekm0rqgverd">
          <header className="lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-114" data-mp="3czfms3kkof85">
            <p className="text-[13px] font-semibold text-gold-deep" data-id="element-115" data-mp="381nqyygt48yo">
              Memory Care Activity Ready · for activity professionals
            </p>
            <h1 className="mt-3 font-display text-[34px] font-bold leading-[1.08] tracking-tight text-ink sm:text-5xl lg:text-[58px]" data-id="element-116" data-mp="3o7bzrwu0yng3">
              Prep one activity.{' '}
              <span className="italic text-plum-mid" data-id="element-117" data-mp="39cpcutwbfj2d">
                Run it three ways, for every resident in the room.
              </span>
            </h1>
          </header>

          <figure className="-mx-5 sm:mx-0 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:self-center" data-id="element-118" data-mp="30ggab6d1k4c0">
            <img src={PRODUCT_IMAGE} alt="The Memory Care Activity Ready book standing on a wooden table in a bright memory care lounge, with residents doing activities in the background" width={1024} height={1024} className="aspect-square w-full object-cover sm:rounded-3xl sm:border sm:border-cream-line sm:shadow-card" data-id="element-119" data-mp="35a2hwk4cli0y" />
          </figure>

          <div className="lg:col-start-1 lg:row-start-2" data-id="element-120" data-mp="s21hi9lxc9yx">
            <p className="max-w-xl text-[17px] leading-relaxed text-ink-soft sm:text-lg" data-id="element-121" data-mp="s3mcg0c5huxb">
              Memory Care Activity Ready is six volumes and 90 activities, each
              one written at three rungs — DO, HELP and FEEL — so the residents
              who chat, the ones who need a hand, and the ones who respond
              mainly to touch and sound all have a way to take part in the same
              session.
            </p>
            <ul className="mt-5 flex flex-wrap gap-2" data-id="element-122" data-mp="161t1qs31amld">
              {chips.map(chip => <li key={chip} className="rounded-full border border-cream-line bg-white px-3 py-1.5 text-[13px] font-semibold text-ink-soft" data-id="element-123" data-mp="112pvx5f8cccc">
                  {chip}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-9 flex flex-col items-center" data-id="element-124" data-mp="3hrdacyaa5g1h">
          <div className="w-full sm:max-w-md" data-id="element-125" data-mp="3hpsff7k1zv33">
            <CtaButton data-id="element-126" data-mp="1x9kwssxc7gkd">Get Memory Care Activity Ready</CtaButton>
          </div>
          <div className="mt-5" data-id="element-127" data-mp="1x7hw9eyk651e">
            <LadderLegend data-id="element-128" data-mp="21a4rlpufu83c" />
          </div>
          <p className="mt-4 max-w-md text-center text-sm text-ink-soft" data-id="element-129" data-mp="21b61vs3mqqk0">
            Written for activity directors, life enrichment and lifestyle
            coordinators, and recreation staff in memory care. No subscription,
            no certification required.
          </p>

          <ul className="mt-5 flex flex-col items-start gap-2 text-[13px] text-ink-soft sm:flex-row sm:flex-wrap sm:justify-center sm:gap-x-5" data-id="element-130" data-mp="2fz0xbg90v90s">
            {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-131" data-mp="2p1jy7ut8zbke">
                <span className="h-1.5 w-1.5 flex-none rounded-full bg-gold" data-id="element-132" data-mp="2tzljmme5bmz1" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}